module.exports = __webpack_public_path__ + "img/Refah.6a355841.svg";